export enum CiqEventType {
  Conferences = 149,
  EarningsCalls = 48,
  AnalystInvestorDay = 192,
  MA = 52
}
